import { NavOptionsProps } from "../interfaces/navigation";

export const navOptions: NavOptionsProps[] = [
    {
        title: "Buscar",
        to: "/search",
        id: "search"
    },
    {
        title: "Vende tu auto",
        to: "/sell",
        id: "sell"
    },
    {
        title: "Notificaciones",
        to: "/notifications",
        id: "notifications"
    },
    {
        title: "Ingresar",
        to: "/",
        id: "login"
    }
];